import { Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  AcademicCapIcon,
  ReceiptRefundIcon,
  CashIcon,
  ClockIcon,
  BadgeCheckIcon,
  UsersIcon,
} from "@heroicons/react/solid";
import "./style.css";
import { IoChevronBackOutline } from "react-icons/io5";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ComprarNFT() {
  const [isOpenNft0, setIsOpenNft0] = useState(false);
  const [isOpenNft1, setIsOpenNft1] = useState(false);
  const [isOpenNft2, setIsOpenNft2] = useState(false);
  const [isOpenNft3, setIsOpenNft3] = useState(false);
  const [isOpenNft4, setIsOpenNft4] = useState(false);
  const [isOpenNft5, setIsOpenNft5] = useState(false);
  const [isOpenNft6, setIsOpenNft6] = useState(false);
  const [isOpenNft7, setIsOpenNft7] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-neutral-900">
      <div class="page-bg animation-wrapper">
        <div class="particle particle-1"></div>
      </div>
      <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-6">
          <h1 class="text-white mt-2 block uppercase text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
            Comprando NFTs
          </h1>
          <h3 class="block text-xl text-violet-600 font-semibold tracking-wide ">
            Más información sobre cómo comprar NFT
          </h3>

          <a href="/learn" className="font-bold ml-2 text-left flex text-white">
            <IoChevronBackOutline className="mr-2 mt-1" /> volver 
            </a>
          <ul role="list" class="space-y-3 text-left">
            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft0(!isOpenNft0)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Comprando criptomonedas para comprar NFTs
                </h2>
                <svg
                  className={`${
                    isOpenNft0
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft0}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Ok, has decidido comprar un NFT. ¿Ahora qué? Según el NFT
                      que desees comprar y la cadena de bloques en la que se
                      incluirá, deberás comprar algunas criptomonedas.
                    </p>
                    <p>
                      En este ejemplo, digamos que tu NFT está en Ethereum
                      Blockchain. Lo más probable es que tu NFT requiera una
                      compra en la moneda ETH. (Para Solana, sería SOL y Tezos
                      sería XTZ, y otras cadenas de bloques tendrán su propia
                      moneda nativa).
                    </p>
                    <p>
                      Para obtener criptomonedas con moneda fiduciaria (moneda
                      utilizada en el mundo real), se necesitará lo que se
                      conoce como rampa de acceso (solo una forma elegante de
                      decir una herramienta o servicio para obtener dinero del
                      mundo real en los mercados de criptomonedas). Hay dos
                      formas principales de hacer esto, que incluyen:
                    </p>
                    <ul className="list-decimal">
                      <li>
                        Uso de un intercambio centralizado. Estas son compañías
                        de las que quizás hayas oído hablar, incluidas{" "}
                        <strong>
                          Binance, Coinbase, Koinly, Gemini, Crypto.com, Kraken,
                          eToro y muchas otras
                        </strong>
                        , según el lugar donde vivas. Si usas un intercambio
                        centralizado, deberás proporcionar tu información
                        personal para permitirte intercambiar criptomonedas
                        utilizando sus servicios. Habiendo dicho eso, los
                        intercambios centralizados son las rampas de acceso más
                        comunes a las criptomonedas.{" "}
                        <strong>
                          Desde aquí, tu criptomoneda deberá enviarse a una
                          billetera sin custodia de tu elección (las opciones
                          populares incluyen MetaMask y Coinbase Wallet, pero
                          hay otras), donde estarás listo para comprar un NFT.
                        </strong>
                      </li>
                      <br />
                      <li>
                        Usando pasarelas de pago e incluyendo servicios como
                        <strong>
                          Moonpay, Wyre, Ramp Network, Transak, por ejemplo.
                        </strong>{" "}
                        Cada semana, llegan al mercado aún más servicios, lo que
                        aumenta las ofertas disponibles y hace que las
                        criptomonedas sean más accesibles para todos.{" "}
                        <strong>
                          Estos servicios permiten a las personas omitir los
                          intercambios centralizados y comprar criptomonedas
                          utilizando una variedad de métodos de pago donde la
                          criptomoneda comprada se deposita directamente en una
                          cartera de criptomonedas de tu elección.
                        </strong>{" "}
                        Esto te ahorra la molestia de tener que transferir
                        criptomonedas desde un intercambio centralizado que
                        retiene tus fondos en una cartera sin custodia.
                      </li>
                      <br />
                      <p>
                        Independientemente de la forma en que realices la compra
                        de criptomonedas, siempre que las tengas listas en una
                        cartera sin custodia (de criptomonedas), estarás listo
                        para dar los siguientes pasos en tu proceso de compra de
                        NFT.
                      </p>
                      <br />
                    </ul>
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft1(!isOpenNft1)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Enviando criptomonedas a MetaMask
                </h2>
                <svg
                  className={`${
                    isOpenNft1
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft1}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Entonces, has comprado criptomonedas y, para este ejemplo,
                      supongamos que está en forma de ETH en tu cuenta de
                      intercambio centralizado, “centralized exchange (CEX)”.
                    </p>

                    <p>
                      Para transferir tu ETH desde tu CEX, deberás tener una
                      cartera sin custodia para enviar esto. La mayoría de los
                      usuarios tienen una cartera de MetaMask. Si no lo haces,
                      tendrás que configurar uno. Una vez que la hayas
                      configurado, estarás listo para recibir ETH desde tu
                      cuenta CEX.
                    </p>

                    <p>
                      <strong>
                        En tu cuenta CEX, busca tu cartera ETH y selecciona la
                        opción a menudo llamada "ENVIAR"
                      </strong>
                      . Bajo esta opción, se te pedirá información clave. Esto
                      incluirá:
                    </p>

                    <ul className="list-decimal">
                      <li>
                        <strong>
                          Token (o criptomoneda) que deseas enviar
                        </strong>
                        . En este caso, sería ETH.
                      </li>
                      <br />
                      <li>
                        <strong>Cantidad que deseas enviar</strong>. Deberás
                        seleccionar cuánto deseas transferir. Al realizar la
                        transferencia, piensa en los costos asociados con la
                        gasolina (gas fee) tanto para lo que estás enviando como
                        para los costos de la gasolina cuando gastas tus ETH.
                        Esto puede ser difícil de estimar, pero siempre es útil
                        tener más que el mínimo indispensable.
                      </li>
                      <br />
                      <li>
                        <strong>Dirección de la cartera.</strong> Esta dirección
                        es la que puedes encontrar en tu extensión o aplicación
                        de MetaMask. Cuando abres tu cartera de MetaMask, la
                        dirección de la cartera se puede ver debajo del nombre
                        de tu cuenta. Comenzará con "0x". Asegúrate de copiar
                        esta dirección cuidadosamente en el campo de dirección
                        de la cartera en tu página de envío de CEX.
                      </li>
                      <br />
                      <p>
                        <strong>NOTA: </strong> Ten cuenta que es probable que
                        hayan advertencias sobre asegurarse de que estás
                        enviando a una dirección que es capaz de recibir tokens
                        ERC20 y que la dirección de tu cartera es correcta.
                        Estas advertencias son importantes porque si la
                        dirección de tu cartera no es 100% precisa, tus fondos
                        se perderán para siempre. Desafortunadamente, no hay
                        forma de recuperarlos.
                      </p>
                      <br />
                      <p>
                        También se proporcionará una tasa estimada por la
                        cantidad de gas que pagarás por la transacción.
                        Programar transacciones con períodos de poca gasolina
                        significa que pagarás menos tasa por la transferencia.
                      </p>
                      <br />
                      <p>
                        <strong>
                          Una vez que hayas ingresado la información anterior y
                          hayas vuelto a confirmar que la cartera de destino es
                          correcta, presiona ENVIAR. Una vez que la transacción
                          haya sido confirmada en la cadena de bloques, el ETH
                          estará listo para ti en tu billetera de MetaMask.
                        </strong>
                      </p>
                      <br />
                    </ul>
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft2(!isOpenNft2)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Dónde comprar un NFT
                </h2>
                <svg
                  className={`${
                    isOpenNft2
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft2}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Cuando tienes tu cartera cargada con criptomonedas para
                      una compra de NFT, hay varias formas de comprar uno. Una
                      forma es a través del minteo, que es la creación de un NFT
                      en la cadena de bloques, y otra es mediante la compra de
                      NFT existentes en un mercado secundario.
                    </p>
                    <p>
                      Cada mercado tiene un papel que desempeñar en el
                      ecosistema general con compradores y vendedores de nicho.
                      Algunos son más adecuados para artistas y coleccionistas
                      de arte y otros están dirigidos a un grupo demográfico más
                      amplio. Los mercados de Ethereum más utilizados para
                      comprar y vender NFT incluyen:
                    </p>
                    <p>
                      <strong>
                        <a href="https://opensea.io/">OpenSea: </a>
                      </strong>
                      Este mercado es el más grande y actualmente el más activo
                      para comprar y vender NFT. Admite NFT en la red Ethereum
                      (red principal y cadena lateral de Polygon), así como en
                      Solana. Incluye todo tipo de colecciones desde PFPs, hasta
                      1/1 arte, fotografía, música, etc. Opensea cobra un 2,5%
                      de fee por cada venta realizada en la plataforma.
                    </p>
                    <p>
                      <strong>
                        <a href="https://looksrare.org/">LooksRare: </a>
                      </strong>
                      Un competidor de Opensea que se lanzó a finales del 2021.
                      Los usuarios pueden ganar tokens LOOKS por comprar y
                      vender usando LooksRare, y la tarifade servicio es del
                      2.0%.
                    </p>
                    <p>
                      <strong>
                        <a href="https://rarible.com/">Rarible: </a>
                      </strong>
                      Un mercado menos conocido que tiene una oferta similar a
                      Opensea y LooksRare, y cobra una tarifa del 2,5 % en cada
                      compra y venta en la plataforma.
                    </p>
                    <p>
                      <strong>
                        <a href="https://niftygateway.com/marketplace">
                          Nifty Gateway:{" "}
                        </a>
                      </strong>
                      Se lanzó al mercado en abril de 2022. Nifty Gateway
                      tratará de enfrentarse a los grandes mercados para
                      posicionarse en él. Permite una fácil incorporación de los
                      usuarios al mundo de los NFTs al aceptar pagos en moneda
                      fiduciaria además de la criptomoneda.
                    </p>
                    <p>
                      <strong>
                        <a href="https://foundation.app/">Foundation: </a>
                      </strong>
                      Un mercado para el arte 1/1 de varios medios (piezas
                      digitales, fotográficas, de bellas artes). Las ventas son
                      por subasta, y empiezan cuando se realiza una oferta
                      mínima.
                    </p>
                    <p>
                      <strong>
                        <a href="https://superrare.com/">SuperRare: </a>
                      </strong>
                      Un mercado de NFTs de arte digital, a menudo diseñado para
                      exhibir bellas artes y fotografía. Los precios del arte en
                      esta plataforma son generalmente más altos que en otras.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft3(!isOpenNft3)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Comprando en OpenSea
                </h2>
                <svg
                  className={`${
                    isOpenNft3
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft3}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      OpenSea es un mercado líder de tokens no fungibles o Non
                      Fungible Tokens (NFT) donde puedes comprar y vender tus
                      activos. Para comenzar, conecta tu cartera de
                      criptomonedas como MetaMask a OpenSea. Para hacer esto,
                      puedes ir a la esquina superior derecha de la página y
                      hacer clic en el ícono de la billetera. Aparecerá un
                      mensaje donde puedes elegir qué cartera conectar. Una vez
                      que hayas hecho eso, ¡tu cuenta estará activa!
                    </p>
                    <p>
                      Después de conectar tu cartera, OpenSea traerá su página
                      de perfil donde puedes ver los NFTs que has recopilado o
                      marcado como favoritos. Puedes personalizar tu perfil con
                      una imagen de perfil y un banner, así como cambiar tu
                      nombre de usuario ya que la cuenta predeterminada será
                      "Sin nombre" hasta que la edites.
                    </p>
                    <p>
                      Una vez que esté configurado, puedes encontrar un NFT que
                      te gustaría comprar en el mercado. Revisa todos los
                      detalles del NFT antes de comprar, ya que puede haber
                      propiedades específicas que sean más valiosas. Cuando
                      estés listo, puedes hacer clic en el botón "Comprar ahora"
                      y OpenSea te pedirá que revises los detalles de tu compra.
                      Haz clic en "Pagar" para abrir un aviso dentro de tu
                      cartera que mostrará las tarifas finales. Revisa los
                      costos y verifica que el precio del NFT es correcto y si
                      las tarifas son aceptables antes de hacer clic en
                      "Confirmar".
                    </p>
                    <p>
                      Una vez que la transacción se haya confirmado por
                      completo, ¡eres un orgulloso propietario de un NFT!
                    </p>
                    <p>
                      Para ver tu NFT recién comprado, regresa a tu perfil y
                      luego selecciona "En la cartera" ubicado en el lado
                      izquierdo de la página. Si no aparece de inmediato, es
                      posible que se tarde un poco, así que vuelve a consultar
                      en unos minutos.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft4(!isOpenNft4)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Comprando en LooksRare
                </h2>
                <svg
                  className={`${
                    isOpenNft4
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft4}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      LooksRare se presenta como un mercado de NFT que da
                      prioridad a la comunidad. Es exclusivo de los otros
                      mercados enumerados aquí, ya que permite a sus usuarios
                      obtener recompensas comprando o vendiendo NFTs.
                    </p>
                    <p>
                      LOOKS es la criptomoneda nativa del mercado. Todos los
                      usuarios pueden ganar LOOKS al participar en el mercado.
                      Estos tokens se pueden apostar de forma activa o pasiva
                      para obtener recompensas adicionales.
                    </p>
                    <p>Hay tres formas de comprar un NFT de LooksRare:</p>
                    <ul>
                      <li>
                        Haciendo una oferta en una colección: Esta es una
                        característica única que te permite hacer la misma
                        oferta en cada artículo de la colección. Si una persona
                        acepta tu oferta, se eliminará tu oferta en todos los
                        demás artículos de la colección.
                      </li>
                      <li>
                        Haciendo una oferta o comprando ahora: Cuando eliges
                        "comprar ahora", estás comprando el NFT por el precio
                        indicado. Cuando eliges "ofertar", estás eligiendo
                        ofrecer un precio diferente al que figura en la lista
                        con la esperanza de que el vendedor acepte.
                      </li>
                    </ul>
                    <p>LooksRare tiene un proceso de dos pasos para comprar.</p>
                    <p>
                      <strong>Paso 1:</strong> Te llevará a la cartera de
                      MetaMask para otorgar permiso a LooksRare para acceder y
                      gastar tus ETH.
                    </p>
                    <p>
                      <i>
                        Sugerencias: la función "Editar permisos" te permite
                        controlar cuántos ETH Looksrare tiene la capacidad de
                        gastar. Si bien tu compra puede ser de 0,069 en total
                        (precio NFT + gasolina), MetaMask de forma
                        predeterminada te dará permiso para gastar
                        significativamente más que ese precio. El valor
                        predeterminado suele ser asegurarse de que tienes
                        suficiente margen de maniobra para las tarifas de gas
                        que normalmente fluctúan cada 15-30 segundos.
                      </i>
                    </p>
                    <p>
                      <strong>Paso 2:</strong> Después de presionar confirmar en
                      tu billetera, serás redirigido a LooksRare. Aquí es donde
                      confirmarás y terminarás tu compra.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft5(!isOpenNft5)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Comprando en Rarible
                </h2>
                <svg
                  className={`${
                    isOpenNft5
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft5}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Rarible es un mercado NFT multicadena. En otras palabras,
                      puedes comprar, mintear y vender NFTs en múltiples cadenas
                      de bloques como Etherum, Tezos y Flow. RARI se puede ganar
                      usando activamente la plataforma Rarible a través de la
                      compra y venta.
                    </p>
                    <p>
                      <strong>¿Cómo comprar en Rarible?</strong>
                    </p>
                    <p>
                      Primero, conecta tu cartera de MetaMask en tu navegador a
                      la plataforma Rarible haciendo clic en el botón
                      "conectar". Luego, cuando lo solicite, acepta los Términos
                      de servicio de Rarible y estarás listo para comenzar a
                      comprar tus NFTs.
                    </p>
                    <p>
                      Al igual que otros mercados de NFT, puedes comprar uno de
                      inmediato por el precio indicado o puedes realizar una
                      oferta por un precio diferente.
                    </p>
                    <p>
                      Al realizar una oferta, tus ETH se convertirán en WETH
                      (éter envuelto) y, después de confirmar, se realizará tu
                      oferta.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft6(!isOpenNft6)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Comprando en Nifty GateWay
                </h2>
                <svg
                  className={`${
                    isOpenNft6
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft6}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Nifty Gateway funciona de una manera única en comparación
                      con otros mercados de NFT. No funciona como OpenSea y
                      mercados secundarios similares, así que eliminemos esa
                      imagen de inmediato.
                    </p>
                    <p>
                      Una de las diferencias clave es que Nifty Gateway es, lo
                      que ellos llaman, una "plataforma de custodia".
                      Básicamente, esto significa que los NFT en su plataforma
                      se almacenan en una cartera segura, “impulsada por la
                      tecnología de custodia de última generación de Gemini", lo
                      que significa que en realidad no tiene que usar la cadena
                      de bloques cuando opera.
                    </p>
                    <p>
                      Dicho de otra manera, son un mercado NFT “centralizado”, a
                      diferencia de los mercados descentralizados, como OpenSea
                      mencionado anteriormente. En última instancia, esto
                      significa que su mercado está controlado por una autoridad
                      central. Este es un atributo fantástico, ya que permite a
                      los coleccionistas participar en el mercado sin tarifas de
                      gas despiadadas, mientras que la seguridad es
                      presumiblemente mucho mejor.
                    </p>
                    <p>
                      Además, si pierdes el acceso a tu cuenta (que no todos
                      estamos tan secretamente petrificados) no tienes que
                      buscar entre basureros para buscar frases semillas
                      perdidas en viejos cuadernos tirados. El equipo puede
                      ayudarte a recuperar el acceso a su plataforma y a tus
                      NFTs.
                    </p>
                    <p>
                      Nifty Gateway también trabaja directamente con proyectos,
                      artistas y marcas para crear colecciones de arte digital
                      exclusivas de la plataforma. Su objetivo es muy claro: "No
                      descansaremos hasta que mil millones de personas
                      recolecten NFTs".
                    </p>
                    <p>
                      El equipo de Nifty Gateway tiene mucho cuidado al decidir
                      qué NFT se aceptará en la plataforma. Como se indica en su
                      sitio web, “los artistas deben pasar un proceso de
                      solicitud y una entrevista antes de poder mintear y emitir
                      NFT. Esto garantiza que todas las colecciones de obras de
                      arte sean de alta calidad y ayuda a mantener la reputación
                      de primera de la plataforma”. Esta es una forma mucho más
                      segura de comerciar con NFT que en otros mercados
                      secundarios que permiten a cualquiera listar casi
                      cualquier cosa a la venta, incluidas copias de proyectos
                      legítimos.
                    </p>
                    <p>
                      Nifty Gateway lanza NFTs a través de “drops”, que solo
                      están disponibles por un período de tiempo limitado. Estos
                      drops pueden ser "curated drops” o "drops verificados".
                    </p>
                    <p>
                      Un “curated drop” es aquel que vende directamente el
                      propietario, mientras que los NFT de 'drops verified' no
                      son controlados por Nifty Gateway. El equipo esencialmente
                      verifica la colección de NFT, y debe cumplir con sus
                      estándares legales y básicos de contratos inteligentes.
                      Nuevamente, otra victoria para la seguridad al invertir en
                      NFT.
                    </p>
                    <p>
                      También tienen un boletín digital que brinda a los
                      lectores actualizaciones sobre los próximos lanzamientos
                      de NFT, así que está atento a esto. Los comerciantes
                      también pueden registrarse previamente para ciertos drops
                      más populares con anticipación para asegurarse de que
                      puedan coleccionar.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft7(!isOpenNft7)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Comprando en Foundation
                </h2>
                <svg
                  className={`${
                    isOpenNft7
                      ? "rotate-180 h-6 w-6 transform text-gray-400"
                      : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft7}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Foundation es un mercado de NFT que se especializa en arte
                      1/1. Se requiere una invitación para que un artista mintee
                      sus piezas, sin embargo, cualquiera puede comprar NFT a
                      través de subasta o compra inmediata.
                    </p>
                    <p>
                      <strong>Para comprar:</strong>
                    </p>
                    <ul className="list-decimal">
                      <li>
                        Haz clic en las tres líneas en la esquina superior
                        derecha.
                      </li>
                      <li>
                        Desplázate hacia abajo hasta la barra negra (Conectar
                        cartera).{" "}
                      </li>
                      <li>
                        Selecciona MetaMask o WalletConnect. Inicia sesión y
                        acepta la conexión, luego firma la solicitud de firma
                        para conectar tu cartera a Foundation.
                      </li>
                      <li>
                        Haz tu oferta o compra ahora, verifica el gas y revisa
                        el contrato, luego envíalo.
                      </li>
                    </ul>

                    <p>
                      Podrás ver los NFTs que posees en Foundation dentro de tu
                      perfil, que se encuentra haciendo clic en el pequeño
                      círculo en la parte superior derecha con tu foto de
                      perfil. También puedes verlos dentro de tu cartera.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
